import { styled } from '@mui/material';

const PREFIX = 'SignUp';

export const signUpClasses = {
  root: `${PREFIX}-root`,
  paper: `${PREFIX}-paper`,
  progressBar: `${PREFIX}-progressBar`,
  top: `${PREFIX}-top`,
  bottom: `${PREFIX}-bottom`,
  signInLink: `${PREFIX}-signInLink`,
};

export const SignUpRoot = styled('div')(({ theme }) => ({
  [`&.${signUpClasses.root}`]: {
    width: '100%',
    minWidth: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  [`& .${signUpClasses.paper}`]: {
    minWidth: '500px',
    width: '32.563rem',
  },

  [`& .${signUpClasses.progressBar}`]: {
    padding: `${theme.spacing(8)}px ${theme.spacing(4)}px`,
  },

  [`& .${signUpClasses.top}`]: {
    width: '32.563rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },

  [`& .${signUpClasses.bottom}`]: {
    width: '100%',
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },

  [`& .${signUpClasses.signInLink}`]: {
    marginLeft: '1em',
  },
}));
